import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { levelsItemResourceType } from "./levelsResourceConsts";

export const levelsItemIdentifierStruct = createIdentifierStruct(
  levelsItemResourceType
);
